module.exports = __webpack_public_path__ + "img/sasslogo.b7fb94a6.png";